import { makeGetRequest, makePostRequest } from "../makeRequest";
import appConfig from "../../config/app.config";

export const getAllCampaignRules = async () => {
  console.log("rule");
  try {
    const allActivitiesData = await makeGetRequest(appConfig.apiUrl.getRules);
    return allActivitiesData.data;
  } catch (error) {
    return error?.response.data || error?.response;
  }
};

export const getAllBonusActivities = async () => {
  try {
    const allBonusActivitiesData = await makeGetRequest(
      appConfig.apiUrl.getBonusActivityList
    );
    return allBonusActivitiesData.data;
  } catch (error) {
    return error?.response.data || error?.response;
  }
};

export const createBonusCampaignActivity = async (body) => {
  try {
    const createBonusActivitiesData = await makePostRequest(
      appConfig.apiUrl.createBonusCampaignActivity,
      body
    );
    return createBonusActivitiesData.data;
  } catch (error) {
    return error?.response.data || error?.response;
  }
};

export const createBonusCampaignActivityRule = async (body) => {
  try {
    const createBonusCampaignActivityRuleData = await makePostRequest(
      appConfig.apiUrl.createBonusCampaignActivityRule,
      body
    );
    return createBonusCampaignActivityRuleData.data;
  } catch (error) {
    return error?.response.data || error?.response;
  }
};

export const updateCampaignStatus = async (body) => {
  try {
    const updateCampaignStatusData = await makePostRequest(
      appConfig.apiUrl.updateCampaignStatus,
      body
    );
    return updateCampaignStatusData.data;
  } catch (error) {
    return error?.response.data || error?.response;
  }
};
